export default {
	'report-warning-dull-products': {
		id: 'report-warning-dull-products',
		label: '呆滞品预警报表',
		code: '0008_0008'
	}
}
